import { SR_API_ACTION_UTILITY_VERIFY_PHONE_SMS_CODE_REQUESTED } from 'api/utilityActionTypes';

export default async function resetPasswordSmsCodeRequested(
  { state, utilityApiClient },
  { phone, isUtilityProfit },
) {
  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_VERIFY_PHONE_SMS_CODE_REQUESTED,
    state: state,
    payload: {
      phone,
      isUtilityProfit,
    },
    onSuccess() {
      state.set(['resetPasswordForm', 'phone'], phone);
    },
  });
}
